$(document).on('click','.lion-header_quick-links a,.earn-points-link,.redeem-points-link',function(e) {
  e.preventDefault();
  var target = $(this).attr('href');

  $('html, body').animate({
    scrollTop: $(target).offset().top
  }, 1000); 
});

$(document).on('click','.earn-points-link,.redeem-points-link',function(e) {
  e.preventDefault();
  var target = $(this).attr('href');
  $('.feature-tabs ul li.active').removeClass('active');
  $('.feature-tabs #tab1').addClass('active');
  $('.account-tab-content').hide();
  $('#content1').show();

  $('html, body').animate({
    scrollTop: $(target).offset().top - 25
  }, 1000); 
});

$(document).on('click','.product__image-icon',function() {
  var video = $(this).next('video')[0];;
  if (video.paused || video.ended) {
    video.play();
    $(this).hide();
  } else {
    video.pause();
    $(this).show();
  }
});

$(document).ready(function() {
  var video = $('.product__image-icon').next('video')[0];
  if(video){
    video.play();
  }
  $('.product__image-icon').hide();
});

$(document).on('click','.link_popup',function() {
  var popupLink = $(this).data('popup');
  $('.popup_content-container[data-popup="'+ popupLink +'"]').toggleClass("active");
});
$(document).on('click','.link-popup__donation',function() {
  var popupLink = $(this).data('popup');
  $('.popup_content-container[data-popup="'+ popupLink +'"]').toggleClass("active");
});
$(document).on('click','.link-popup__close',function() {
  $(this).closest('.popup_content-container').toggleClass("active");
});

$(document).click(function(event) {
  if ($(event.target).hasClass("popup_content-container")) {
    $('.popup_content-container.active').toggleClass("active");
  }
});

$(document).on('click','.single-variant-option',function(){
  $('.single-variant-option').removeClass('active');
  $(this).addClass('active');
  $('.sticky-add-to-cart').removeAttr('disabled');
});

/* engraving */
$(document).ready(function () {
  var modal = $("#engravingModal");
  var modalBtn = $(".engraving_link");
  var modalSpan = $(".engraving-options_container .close");

  // When the user clicks the button, open the modal
  modalBtn.click(function () {
    modal.css("display", "block");
  });

  // When the user clicks on <span> (x), close the modal
  modalSpan.click(function () {
    modal.css("display", "none");
  });

  // When the user clicks anywhere outside of the modal, close it
  $(window).click(function (event) {
    if (event.target === modal[0]) {
      modal.css("display", "none");
    }
  });
});

$(document).on('click','.engraving_option-values p',function(){
  $(this).closest('.engraving_option-values').find('p').removeClass('active');
  $(this).addClass('active');
  var dataValue = $(this).data('value');
  if(dataValue == 'select'){
    var selectedVal = $(this).data('position');
    /* $('.engraving-fields').addClass('hide').removeClass('active'); */
    $('.engraving-fields').each(function () {
        var isEmpty = true;
        $(this).find('input').each(function () {
            if ($(this).val().trim() !== '') {
                isEmpty = false;
            }
        });
        if (isEmpty) {
            $(this).addClass('hide').removeClass('active');
        }
    });
    console.log('selectedVal',selectedVal);
    /* $('.engraving_option-values').removeClass('hide');
    $('#engravingModal [data-value="'+ selectedVal +'"]').find('.engraving_option-values').addClass('hide'); */
    $('#engravingModal [data-value="'+ selectedVal +'"]').find('.engraving_option-values p').removeClass('active');
    $('#engravingModal [data-value="'+ selectedVal +'"]').find('.engraving_option-values p[data-value="'+ dataValue +'"]').addClass('active');
    $('#engravingModal [data-value="'+ selectedVal +'"]').find('.engraving-fields').removeClass('hide').addClass('active');

    var dataFont = $('#engravingModal [data-value="'+ selectedVal +'"]').find('.engraving-fonts-list p.active').data('font');
    $('.engraving-font--preview img').addClass('hide');
    $('.engraving-font--preview img[alt="' + dataFont + '"]').removeClass('hide');
  }
});

// $(document).on("input",".engraving-text", function() {
//   var inputValue = $(this).val();
//   var dataField = $(this).data('field');
//    var $inputField = $("input." + dataField);
//    if ($inputField.length > 0) {
//      $($inputField).val(inputValue);
//    }  
//   var charCount = inputValue.length;
//   if (charCount > 0) {
//     $('.engraving-addtocart').prop('disabled', false);
//   }else{
//     $('.engraving-addtocart').prop('disabled', true);
//   }
// });

$(document).on("input", ".engraving-text", function() {
  var inputValue = $(this).val();
  var dataField = $(this).data('field');
  if ($(this).val().trim() !== '') {
    $(this).addClass('has-content');
  } else {
    $(this).removeClass('has-content');
  }
  /*var $inputField = $("input." + dataField);
  
  if ($inputField.length > 0) {
    $($inputField).val(inputValue);
  } */

  // Check the length of the input and the state of the checkbox
  var charCount = inputValue.length;
  var isCheckboxChecked = $('#termsCheckbox').is(':checked');
  
  if (charCount > 0 && isCheckboxChecked) {
    $('.engraving-addtocart').prop('disabled', false);
  } else {
    $('.engraving-addtocart').prop('disabled', true);
  }
});

// Also, listen for checkbox changes
$(document).on("change", "#termsCheckbox", function() {
  var isCheckboxChecked = $(this).is(':checked');
  var engravingTextFilled = $('.engraving-fields.active .engraving-text').val().length > 0;

  if (isCheckboxChecked && engravingTextFilled) {
    $('.engraving-addtocart').prop('disabled', false);
  } else {
    $('.engraving-addtocart').prop('disabled', true);
  }
});


$(document).on('click','.engraving-fonts-list p',function(){
  $(this).closest('.engraving-fonts-list').find('p').removeClass('active');
  $(this).addClass('active');
  var dataFont = $(this).data('font');
  $(this).closest('.engraving-fields').find('input[readonly]').css('font-family', dataFont);
  $('.engraving-font--preview img').addClass('hide');
  $('.engraving-font--preview img[alt="' + dataFont + '"]').removeClass('hide');
});

function addItem(qty,id,properties,callback) {
  var params = {quantity:qty,id:id};
  if(properties != false){
      params.properties = properties;
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function(){
      $('[data-add-to-cart]').trigger('click');
      $('#engravingModal').hide();
    },
    error: function(){}
  });
}


$(document).on('click','.engraving-addtocart',function(){
  var qty = 1;
  var id  = $(this).data('product');
  var parent_product  = $(this).data('product-title');
  var parent_id  = $(this).data('mainproduct-id');
  // console.log(parent_id,"parent_id");
  // var engravingSide = $('.engraving-fields.active .engraving-text').attr('name');
  var faceEngraving = $('.engraving-fields.front-engraving-fields .engraving-text').attr('name');
  var frontfontName = $('.engraving-fields.front-engraving-fields .engraving-fonts-list p.active').text();
  var frontenterText = $('.engraving-fields.front-engraving-fields .engraving-text').val();

  var insideEngraving = $('.engraving-fields.inside-engraving-fields .engraving-text').attr('name');
  var insidefontName = $('.engraving-fields.inside-engraving-fields .engraving-fonts-list p.active').text();
  var insideenterText = $('.engraving-fields.inside-engraving-fields .engraving-text').val();

  // var fontName = $('.engraving-fields.active .engraving-fonts-list p.active').text();
  // var enterText = $('.engraving-fields.active .engraving-text').val();
  window.timestampnew = Date.now();
  
  // var properties = {
  //   "Product": parent_product,
  //   "Engraving": engravingSide,
  //   "Font": fontName,
  //   "Engraving text": enterText,
  //   "_endravingid": id,
  //   "_mainproductid": parent_id,
  //   "_timestamp": window.timestampnew
  // } 
  
var properties = {
  "Product": parent_product, 
  "_endravingid": id, 
  "_mainproductid": parent_id, 
  "_timestamp": window.timestampnew
};
if (faceEngraving && frontfontName && frontenterText) {
  properties["Face Engraving"] = faceEngraving;
  properties["Face Font"] = frontfontName;
  properties["Face Engraving text"] = frontenterText;
}
if (insideEngraving && insidefontName && insideenterText) {
  properties["Inside Engraving"] = insideEngraving;
  properties["Inside Font"] = insidefontName;
  properties["Inside Engraving text"] = insideenterText;
}
  console.log(properties,"window.window.timestampnew")
  addItem(qty,id,properties);
});

$(document).on('change','.main-product_variants-mobile',function(){
  var activeVal = $(this).val();
  $('.sticky-add-to-cart').prop('disabled', false);
  $('.main-product_variants .single-variant-option').removeClass('active');
  $('.main-product_variants .single-variant-option[data-variant='+ activeVal +']').addClass('active');
});
/* end engraving */ 

$.fn.equalHeights = function(){
  let maxHeight = 0;
  $(this).each(function(){
    maxHeight = Math.max($(this).height(), maxHeight);
  });
  $(this).each(function(){
    $(this).height(maxHeight);
  });
};

function applyEqualHeights() {
  $('#CollectionAjaxContent .grid[data-scroll-to]').each(function() {
    $(this).find('.grid-product__meta').equalHeights();
    $(this).find('.grid-product__custom_meta').equalHeights();
  });
  if($('.testimonials-slider__text').length > 0){
    $('.testimonials-slider__text').equalHeights(); 
  }
}

$(document).ready(function() {
  applyEqualHeights();
  $(window).resize(function() {
    // Reset heights before recalculating to handle window resize
    $('#CollectionAjaxContent .grid[data-scroll-to] .grid-product__meta, #CollectionAjaxContent .grid[data-scroll-to] .grid-product__custom_meta').css('height', 'auto');
    applyEqualHeights();
  });
});

var accountTabs = document.querySelectorAll('.feature-tabs li');
accountTabs.forEach(function(accountTab, index) {
  accountTab.addEventListener('click', function() {
    if (accountTab.id) {  
      openTab('content' + (index + 1));
    }
  });
});

// Add event listeners to nested tabs dynamically
var nestedTabs = document.querySelectorAll('.nested-tabs li');
nestedTabs.forEach(function(tab, index) {
  tab.addEventListener('click', function() {
    nestedTabs.forEach(function(tab) {
      tab.classList.remove("active");
    });
    // Add "active" class to the clicked nested tab
    tab.classList.add("active");
    openNestedTab('nested-content' + (index + 1));
  });
});

function openNestedTab(tabName) {
  // Hide all nested tab contents
  var accountTabContent = document.querySelector(".nested-tabs").closest(".account-tab-content");

  // Hide all tab contents inside the closest ancestor
  var tabContents = accountTabContent.querySelectorAll(".account-nested-tab-content");
  tabContents.forEach(function(tabContent) {
    tabContent.style.display = "none";
  });
  
  // Show the selected nested tab content
  document.getElementById(tabName).style.display = "block";
}

function openTab(tabName) {
  // Hide all tab contents
  var tabContents = document.getElementsByClassName("account-tab-content");
  for (var i = 0; i < tabContents.length; i++) {
    tabContents[i].style.display = "none";
  }

  // Deactivate all tabs
  var tabLinks = document.querySelectorAll('.feature-tabs li');
  tabLinks.forEach(function(tab) {
    tab.classList.remove("active");
  });

  // Show the selected tab content
  document.getElementById(tabName).style.display = "block";

  // Activate the selected tab
  document.getElementById(tabName.replace("content", "tab")).classList.add("active");
}

$(document).on('click','.reward-tier-information-content a', function(e) {
    var targetHref = $(this).attr('href');
    if (targetHref.indexOf('#') !== -1) {
      e.preventDefault();
      var targetSection = targetHref.replace('#', '.');
      $('html, body').animate({
          scrollTop: $(targetSection).offset().top - 30
      }, 1000);
    }
});

$(document).on('click','.collection_custom_filter_layout--option', function(e) {
    var mainElement = $('#CollectionAjaxContent .collection-grid__wrapper .grid-product');
    $('.collection_custom_filter_layout--option').removeClass('active');           
    $(this).addClass('active');
    var layoutValue = $(this).data('filter');
    if(layoutValue == 'one'){
      $(mainElement).removeClass('small--one-half').addClass('small--one-whole');
    }else if(layoutValue == 'two'){
      $(mainElement).removeClass('medium-up--one-quarter small--one-whole').addClass('medium-up--two-quarters small--one-half');
    }else{
      $(mainElement).removeClass('medium-up--two-quarters').addClass('medium-up--one-quarter');
    }
});
$(document).on('click','.collection_custom_filter_image--option', function(e) {
    var mainElement = $('#CollectionAjaxContent .collection-grid__wrapper .grid-product .grid-product__image-mask');
    $('.collection_custom_filter_image--option').removeClass('active');           
    $(this).addClass('active');
    var layoutValue = $(this).data('filter');
    if(layoutValue == 'on-model'){
      $(mainElement).addClass('on-model');
    }else{
      $(mainElement).removeClass('on-model');
    }
});

$(document).ready(function() {
   function checkScreenSize() {
      var screenWidth = $(window).width();
      var breakpoint = 768;
      var mainElement = $('#CollectionAjaxContent .collection-grid__wrapper .grid-product');
      var activeOption = $('.collection_custom_filter_layout--option.active').data('filter');
      if (screenWidth <= breakpoint) {
        if(activeOption == 'one'){
          $('.collection_custom_filter_layout--option').removeClass('active');
          $('.collection_custom_filter_layout--option[data-filter="one"]').addClass('active');
          $(mainElement).removeClass('small--one-half').addClass('small--one-whole');
        }else{
          $('.collection_custom_filter_layout--option').removeClass('active');
          $('.collection_custom_filter_layout--option[data-filter="two"]').addClass('active');
          $(mainElement).removeClass('small--one-whole').addClass('small--one-half');
        }
      }else{
        $('.collection_custom_filter_layout--option').removeClass('active');
        $('.collection_custom_filter_layout--option[data-filter="four"]').addClass('active');
        $(mainElement).removeClass('medium-up--two-quarters').addClass('medium-up--one-quarter');
      }
   }
  checkScreenSize();
  $(window).resize(checkScreenSize);
});

document.addEventListener('DOMContentLoaded', function() {
  // var elem = document.querySelector('.promo-slider');
  // var flkty = new Flickity(elem, {
  //   cellAlign: 'left',
  //   contain: true,
  //   pageDots: false,
  //   wrapAround: true,
  //   groupCells: 1,
  // });
  var promoElems = document.querySelectorAll('.promo-slider');
  promoElems.forEach(function(promoElem) {
    var promoFlkty = new Flickity(promoElem, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true,
      groupCells: 1,
    });
  });

  var accountElem = document.querySelector('.reward-tiers-list');
  var accountFlkty;

  // Function to initialize or destroy Flickity for reward-tiers-list based on screen size
  function initRewardTiersSlider() {
    var windowWidth = window.innerWidth;

    if (windowWidth < 768) { // Mobile screen threshold
      if (!accountFlkty) {
        accountFlkty = new Flickity(accountElem, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          wrapAround: false,
          groupCells: 1,
        });
      }
    } else {
      // Destroy Flickity if the screen size is larger than mobile size
      if (accountFlkty) {
        accountFlkty.destroy();
        accountFlkty = null; // Reset the slider instance
      }
    }
  }

  // Initialize or destroy Flickity on load
  initRewardTiersSlider();

  // Update Flickity on window resize
  window.addEventListener('resize', function() {
    // flkty.resize();
    initRewardTiersSlider(); // Check screen size and toggle Flickity for reward-tiers-list
  });
});





document.addEventListener('DOMContentLoaded', function() {
  const switchToggle = document.getElementById('add-product-switch');
  
  // Function to add the product to the cart
  function addToCart(variantId, qty, $this) {
    switchToggle.disabled = true; // Disable switch to prevent multiple clicks

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then(data => {
       document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      switchToggle.checked = false; // Revert switch state on error
      alert('There was an error adding the product to the cart.');
    })
    .finally(() => {
      switchToggle.disabled = false; // Re-enable the switch
      if($this){
        $(this).removeClass('btn--loading');
      }
    });
  }

  // Function to remove the product from the cart
  function removeFromCart(variantId) {
    switchToggle.disabled = true; // Disable switch to prevent multiple clicks

    // Fetch the current cart to find the line item
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const item = cart.items.find(item => item.variant_id === variantId);
        if (item) {
          // Remove the item by setting its quantity to 0
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        } else {
          // Item not found in cart, nothing to do
          return Promise.resolve(null);
        }
      })
      .then(response => {
        if (response && !response.ok) {
          throw new Error('Failed to remove from cart');
        }
        return response ? response.json() : null;
      })
      .then(data => {
        if (data) {
          const event = new Event('cart:build');
          document.dispatchEvent(event); 
        }
      })
      .catch(error => {
        console.error('Error removing from cart:', error);
        switchToggle.checked = true; // Revert switch state on error
        alert('There was an error removing the product from the cart.');
      })
      .finally(() => {
        switchToggle.disabled = false; // Re-enable the switch
      });
  }

  // Function to initialize the switch state based on the cart
  function initializeSwitch(variantId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const item = cart.items.find(item => item.variant_id === variantId);
        if (item) {
          switchToggle.checked = true;
        } else {
          switchToggle.checked = false;
        }
      })
      .catch(error => console.error('Error initializing switch:', error));
  }

  // Event listener for the switch toggle
  switchToggle.addEventListener('change', function(event) {
    var variantId = parseInt($('#add-product-switch').val());
    if (event.target.checked) {
      addToCart(variantId,1);
    } else {
      removeFromCart(variantId);
    }
  });

  // Initialize the switch state on page load
  var variantId = parseInt($('#add-product-switch').val());
  initializeSwitch(variantId);

  $(document).on('click','.add-to-cart-btn',function(e){
      e.preventDefault();
      var $this = $(this);
      $this.addClass('btn--loading');
      var variantId = $(this).closest('.drawer_item-info').find('[name="id"]').val();
      addToCart(variantId,1,$this);
  });
  
});

document.addEventListener('DOMContentLoaded', function() {
    let tabLinks = document.querySelectorAll('.tab-link');
    let tabContents = document.querySelectorAll('.single-tab-content');

    if(tabLinks){
      tabLinks.forEach(function(tabLink) {
          tabLink.addEventListener('click', function() {
              let tabId = this.getAttribute('data-tab');
  
              tabLinks.forEach(function(link) {
                  link.classList.remove('active');
              });
  
              tabContents.forEach(function(content) {
                  content.classList.remove('active');
              });
  
              document.getElementById(tabId).classList.add('active');
              this.classList.add('active');
          });
      });
    }
});
function selectElemnt() {
  if (window.innerWidth <= 768) {
    const selectElement = document.querySelector('.main-product_variants-mobile');
    if (selectElement) {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const selectedOptionValue = selectedOption.value;
      const selectedOptionValueInventory = selectedOption.dataset.variantAvailable;  
      const inventory = parseInt(selectedOptionValueInventory); 
      const AtcButton = document.querySelector('.sticky-add-to-cart'); 
      if (AtcButton) {
        if (AtcButton.classList.contains("made-to-order")) {
          AtcButton.innerText = "MADE TO ORDER";
          AtcButton.value = "MADE TO ORDER";
          AtcButton.style.backgroundColor = "#000000"; 
          AtcButton.style.color = "white"; 
        }else if (inventory <= 0) {
          AtcButton.innerText = "Pre-order";
          AtcButton.value = "Pre-order";
          AtcButton.style.backgroundColor = "#d0d0d0"; 
          AtcButton.style.color = "rgb(0, 0, 0)"; 
        } else {
          AtcButton.innerText = "Add to Cart";
          AtcButton.value = "Add-to-Cart";
          AtcButton.style.backgroundColor = "#000000";  
          AtcButton.style.color = "white"; 
        }
      }
    }
  }
}
const selectElement = document.querySelector('.main-product_variants-mobile');
if (selectElement) {
  selectElement.addEventListener('change', function() {
    selectElemnt(); 
  });
}